"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import cx from "classnames";
import Hyperlink from "@ingka/hyperlink";
import { FormFieldProvider } from "./FormFieldContext.mjs";
import HelperText, { CharacterCount } from "@ingka/helper-text";
const getValidity = (valid) => {
  if (valid === true) {
    return "success";
  }
  if (valid === false) {
    return "error";
  }
  if (valid === "warning" || valid === "success" || valid === "error") {
    return valid;
  }
  return void 0;
};
const FormField = (props) => {
  const {
    prefix = "",
    characterLimit = 0,
    children,
    validation = { type: "error" },
    fieldHelper = {},
    shouldValidate = false,
    valid,
    className,
    disabled = false,
    ...other
  } = props;
  const showValidation = shouldValidate && valid !== true && valid !== "success";
  const { id, msg, linkText, link, ...messageProps } = showValidation ? validation : fieldHelper;
  const type = showValidation ? validation.type || "error" : fieldHelper.type;
  const baseClass = `${prefix}form-field`;
  const classes = cx(
    `${baseClass}`,
    type && `${baseClass}--${type}`,
    characterLimit && `${baseClass}--with-character-limit`,
    disabled && `${prefix}disabled`,
    className
  );
  const describedById = id;
  const [characterCount, setCharacterCount] = useState(0);
  const validCharacterLimit = characterLimit !== 0 && characterLimit > 0;
  return /* @__PURE__ */ jsx(
    FormFieldProvider,
    {
      valid: getValidity(valid),
      shouldValidate,
      setCharacterCount,
      children: /* @__PURE__ */ jsxs("div", { className: classes, ...other, children: [
        React.Children.map(children, (child) => {
          if (!React.isValidElement(child))
            return null;
          if (child.props.list)
            return child;
          const extraProps = { describedById: msg ? describedById : null };
          return React.cloneElement(child, extraProps);
        }),
        !disabled && (msg || validCharacterLimit) && /* @__PURE__ */ jsxs("div", { className: `${baseClass}__content`, children: [
          /* @__PURE__ */ jsxs(
            HelperText,
            {
              prefix,
              id,
              shouldValidate,
              valid,
              ...messageProps,
              children: [
                msg,
                linkText && link && /* @__PURE__ */ jsx(Hyperlink, { prefix, url: link, text: linkText })
              ]
            }
          ),
          validCharacterLimit && /* @__PURE__ */ jsx(
            CharacterCount,
            {
              prefix,
              characterCount,
              limit: characterLimit
            }
          )
        ] })
      ] })
    }
  );
};
var FormField_default = FormField;
export {
  FormField_default as default
};
